// extracted by mini-css-extract-plugin
export default {"navbar":"CustomNavbar_navbar__7MJ8S","navbar__container":"CustomNavbar_navbar__container__Vw3g0"};